import React from 'react';

import { createStyles, withStyles, WithStyles } from '@material-ui/core';
import Button, { ButtonProps } from '@material-ui/core/Button';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';

const styles = () =>
  createStyles({
    root: {
      '&:hover': {
        background: 'none',
      },
    },
    label: {
      textDecoration: 'underline',
    },
  });

export interface ButtonNavigateNextProps extends Omit<ButtonProps, 'classes'>, WithStyles<typeof styles> {}

const ButtonNavigateNext: React.FC<ButtonNavigateNextProps> = ({ classes, children, ...rest }) => (
  <Button
    disableRipple
    classes={{
      root: classes.root,
      label: classes.label,
    }}
    {...rest}
  >
    {children}
    <NavigateNextIcon fontSize="small" />
  </Button>
);

export default withStyles(styles)(ButtonNavigateNext);
